module.exports = __webpack_public_path__ + "static/img/HM.87d0a372.svg";